package dk.smark.chat.network

import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.request.*
import io.ktor.http.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

class ChatApiService(
    private val baseUrl: String = "https://dbapi.smark.dk",
    private val client: HttpClient = HttpClient {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                isLenient = true
            })
        }
        install(HttpTimeout) {
            requestTimeoutMillis = 10_000
            connectTimeoutMillis = 10_000
        }
    }
) {

    // ── Prekey bundle ───────────────────────────────────────────────────────

    /** POST /keys/prekey-bundle — upload or refresh this user's key bundle. */
    suspend fun uploadPreKeyBundle(request: UploadPreKeyBundleRequest): Unit =
        client.post("$baseUrl/keys/prekey-bundle") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    /** GET /keys/prekey-bundle/{userId} — fetch another user's bundle (pops one OPK). */
    suspend fun fetchPreKeyBundle(userId: Int): PreKeyBundleResponse =
        client.get("$baseUrl/keys/prekey-bundle/$userId").body()

    // ── Messages ────────────────────────────────────────────────────────────

    /** POST /messages — send an encrypted message envelope to the server. */
    suspend fun sendMessage(request: SendMessageRequest): SendMessageResponse =
        client.post("$baseUrl/messages") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    /** GET /messages/{userId} — poll for new messages addressed to [userId]. */
    suspend fun pollMessages(userId: Int): List<MessageEnvelope> =
        client.get("$baseUrl/messages/$userId").body()

    /** DELETE /messages/{messageId} — acknowledge (delete) a delivered message. */
    suspend fun acknowledgeMessage(messageId: Long): Unit =
        client.delete("$baseUrl/messages/$messageId").body()
}
